export default {
  getterCategories                     : state => state.categories,
  getterCategoriesOrigimVariableItems  : state => state.categories.categories.filter(block => block.originVariables === 'items'),
  getterCategoriesOrigimVariableBlocks : state => state.categories.categories.filter(block => block.originVariables === 'blocks'),
  getterHasInconsistencyInCategories   : state => state.categories && state.categories.categories && state.categories.categories.length ? state.categories.categories.some(block => !block.isValid) : false
};
